import { t } from 'i18next';

import { ErrorResponseErrorItemCodeUser } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeUser, string> => ({
  'user:not_found': t('user.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Användaren existerar inte.',
  }),
  'user:missing_role': t('user.missingRole', {
    ns: 'apiErrorCodes',
    defaultValue: 'Användaren saknar rättigheter.',
  }),
  'user:invalid_registration_token': t('user.invalidRegistrationToken', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ogiltig token.',
  }),
  'user:no_sso_active': t('user.noSsoActive', {
    ns: 'apiErrorCodes',
    defaultValue: 'SSO är inte aktivt.',
  }),
  'user:registration_token_not_found': t('user.registrationTokenNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Registreringstoken finns inte.',
  }),
  'user:not_permitted_on_own_account': t('user.notPermittedOnOwnAccount', {
    ns: 'apiErrorCodes',
    defaultValue: 'Det är inte möjligt att utföra den här åtgärden på ditt egna konto.',
  }),
});
